<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="insert">

              <div class="row">
                <div class="col-12 mb-3">
                  <embed :src="googleMap" type="" id="lokasi" class="w-100 h-100 pe-4 rounded">
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Location Name <span class="text-danger">*</span></label>
                    <input type="text" v-model="currentData.nama_lokasi" placeholder="" required />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Location Code <span class="text-danger">*</span></label>
                    <input type="text" v-model="currentData.kode_lokasi" placeholder="" required />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Lat <span class="text-danger">*</span></label>
                    <input type="text" v-model="currentData.lat" placeholder="" required />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Long <span class="text-danger">*</span></label>
                    <input type="text" v-model="currentData.lng" placeholder="" required />
                  </div>
                </div>
                <div class="col-lg-12 mb-3">
                  <div class="d-flex justify-content-end gap-2">
                    <button type="button" class="btn btn-outline-primary" @click="downloadQr"> <i
                        class="ion ion-qr-scanner me-2"></i>Download QR</button>
                    <button type="button" class="btn btn-primary" @click="cekGoogleMap">Cek</button>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Address</label>
                    <textarea class="form-control" v-model="currentData.alamat">
                    </textarea>
                  </div>

                  <div class="form-group">
                    <label>UMR</label>
                    <input type="text" v-model="currentData.umr" @input="formatCurrency(currentData.umr)" placeholder="Rp. 0">
                  </div>


                </div>

                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2">Update</button>
                  <router-link to="location" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, goPage, AlertBottom, openInNewTab, appendForm, timeout, selectedBranch , rupiahInput, rupiahoutput} from "@/assets/js/function";

export default {
  
  name: "editlocation",
  data() {
    return {
      filter: true,
      title: "Edit Location",
      title1: "manage location",
      namaCompany: '',
      config: "",
      api: "",
      foto_ktp_img: "",
      googleMap: "",

      //data
      currentData: {
        alamat: "",
        nama_lokasi: "",
        kode_lokasi: "",
        lat: "0",
        lng: "0",
      },
      currentDate: new Date,
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 0,
    }

    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'update')

    this.namaCompany = localStorage.getItem('namaCompany');

    //get data
    this.currentData = JSON.parse(localStorage.getItem('currentData'));
    //set lat long and google maps
    this.googleMap = `https://maps.google.com/maps?q=${this.currentData.lat},${this.currentData.lng}&output=embed`;

    this.currentData.lat = parseFloat(this.currentData.lat);
    this.currentData.lng = parseFloat(this.currentData.lng);
    
    this.currentData.umr = rupiahInput(this.currentData.umr)
    // this.googleMap = 'https://maps.google.com/maps?q=' + this.currentData.latlng + '&output=embed';
    // const splittedCoordinates = this.currentData.latlng.split(',');
    // this.currentData.lat = parseFloat(splittedCoordinates[0]);
    // this.currentData.lng = parseFloat(splittedCoordinates[1]);

  },
  
  methods: {
    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },

    formatCurrency(number, index) {
      this.currentData.umr = rupiahInput(number);
    },

    async insert() {
      
      const formData = new FormData();
      appendForm(formData)

      Object.entries(this.currentData).forEach(([key, value]) => {
        formData.append(key, value);
      });
      
      //set to indonesia again to save
      formData.delete("lat");
      formData.delete("lng");
      formData.delete("latlng");

      formData.append('latlng', this.currentData.lat + "," + this.currentData.lng);

      // formData.append('umr', rupiahoutput(this.currentData.umr))
      formData.append('umr', this.currentData.umr ? rupiahoutput(this.currentData.umr) : '');


      // for (let [key, value] of formData.entries()) {
      //   console.log(`${key}: ${value}`);
      // }

      const api = base_url + '/v3/location/update';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      if(data.status){
          AlertBottom(data.message);
          goPage("location");
          
          
      }else {
          AlertPopup2("error", "", data.message, true, 1500);
      }

      
    },

    cekGoogleMap() {
   
      this.googleMap = 'https://maps.google.com/maps?q=' + this.currentData.lat + ',' + this.currentData.lng + '&output=embed';
     
    },

    async downloadQr() {
      
      let formData = new FormData();
      appendForm(formData)


      //set to indonesia again to save
      formData.append('id', this.currentData.id);

      // for (let [key, value] of formData.entries()) {
      //   console.log(`${key}: ${value}`);
      // }

      const api = base_url + '/v3/location/qr';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      if(data.status){
        openInNewTab(data.data.file_report);
          
          
      }else {
        AlertPopup2("error", "", data.message, true, 1500);
      }


      
    }

  },

};
</script>
